import { useState } from 'react'
import Image from 'next/image'

import { Button } from '@wartek-id/button-v1'
import {
  Dialog,
  DialogOverlay,
  DialogContent,
  DialogHeader,
} from '@wartek-id/dialog-v1'
import { Banner, BannerAction, BannerDescription } from '@wartek-id/banner'
import { Text } from '@wartek-id/text'
import { Icon } from '@wartek-id/icon'

import useToggleSdkContext from 'utils/useToogleSdk'

type Props = {
  title?: string
  subtitle?: string
}

export function BannerGantiPeriode({
  title = 'Ganti periode Pengelolaan Kinerja',
  subtitle = 'Kini Anda dapat berpindah antar periode sesuai dengan yang ingin Anda kerjakan. Tekan nama Anda di pojok kanan atas dan pilih “Ganti periode” atau cek cara selengkapnya.',
}: Props) {
  const toggles = useToggleSdkContext()
  const isToggleEnabled = toggles?.['kinerja-use-multiple-period'] ?? false

  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    isToggleEnabled && (
      <>
        <Banner
          animationDuration={300}
          onOpenStateChange={function Ga() {}}
          title={title}
          type="informational"
          closable={false}
        >
          <BannerDescription className="!text-base !text-default">
            {subtitle}
          </BannerDescription>
          <BannerAction>
            <Button
              color="white"
              size="sm"
              onClick={() => setIsDialogOpen(true)}
            >
              Cek caranya
            </Button>
          </BannerAction>
        </Banner>

        <Dialog size="sm" isOpen={isDialogOpen} closeOnOverlayClick={false}>
          <DialogOverlay />
          <DialogContent>
            <DialogHeader title="Cara ganti periode Pengelolaan Kinerja" />

            <div className="p-6 flex flex-col gap-4">
              <div className="flex gap-3">
                <div>
                  <div className="text-center rounded-full bg-icon-default h-6 w-6 text-inverse">
                    1
                  </div>
                </div>
                <div className="flex flex-col gap-1">
                  <Text className="text-base !font-semibold">
                    Tekan nama Anda di pojok kanan atas
                  </Text>
                  <Text className="text-base text-subdued">
                    Setelah itu, tekan “Ganti periode”.
                  </Text>
                  <Image
                    src="/images/ganti-periode/step-1.png"
                    width={255}
                    height={239}
                    alt="step-1"
                  />
                </div>
              </div>

              <div className="flex gap-3">
                <div>
                  <div className="text-center rounded-full bg-icon-default h-6 w-6 text-inverse">
                    2
                  </div>
                </div>
                <div className="flex flex-col gap-1">
                  <div className="flex gap-1 items-center">
                    <Text className="text-base !font-semibold">
                      Tekan tanda panah bawah
                    </Text>
                    <Icon>arrow_drop_down</Icon>
                    <Text className="text-base !font-semibold">
                      untuk ganti periode
                    </Text>
                  </div>
                  <Text className="text-base text-subdued">
                    Periode yang tampil pertama kali adalah periode Anda saat
                    ini. Jika periode belum bisa dimulai, Anda dapat kabari
                    atasan untuk memulainya.
                  </Text>
                  <Image
                    src="/images/ganti-periode/step-2-yearly.png"
                    width={337}
                    height={163}
                    className="!min-w-min !m-0"
                    alt="step-2"
                  />
                </div>
              </div>
              <div className="w-full flex justify-center">
                <Button color="blue" onClick={() => setIsDialogOpen(false)}>
                  Saya mengerti
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </>
    )
  )
}
